<template>
  <div class="jsc-bg">
    <!-- <div class="imgbg"></div> -->
    <!-- 顶部 -->
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">{{ currTitle }}</div>
      <div class="sys-temp">
        <MyWeather ref="weatherTwo"></MyWeather>
        <!-- <div id="he-plugin-simple"></div> -->
      </div>
    </div>
    <MyScale @changeSize="changeSize">
      <!-- 中间 -->
      <div
        class="center d-aligncnter"
        :style="{
          'margin-top': 'calc(' + mySize + 'vw',
        }"
      >
        <div class="center-left" v-if="leftShow" style="margin-top: -16px">
          <div style="height: 500px; width: 512px; overflow: hidden">
            <CurrEnter :enterData="enterData"></CurrEnter>
          </div>

          <div style="height: 342px; width: 512px; margin-top: 16px">
            <yesterday-data
              :dayDate="dayDate"
              @changeDayDate="changeDayDate"
              :dayCollegeData="dayCollegeData"
              :len="10"
              :type="type"
              :canChose="true"
            ></yesterday-data>
          </div>
        </div>
        <div class="center-center" v-if="centerShow" style="margin-left: -20px">
          <div class="j-flex" style="padding: 32px 15% 16px 15%">
            <div class="d-column d-aligncnter">
              <div class="t">当前锻炼人次</div>
              <div class="num">{{ currVenuesData.nowRunCount }}</div>
            </div>
            <div class="d-column d-aligncnter">
              <div class="t">今日锻炼人次</div>
              <div class="num">{{ currVenuesData.toDayRunCount }}</div>
            </div>
            <div class="d-column d-aligncnter">
              <div class="t">昨日锻炼人次</div>
              <div class="num">{{ currVenuesData.lastRunCount }}</div>
            </div>
            <div class="d-column d-aligncnter">
              <div class="t">累计锻炼人次</div>
              <div class="num">{{ currVenuesData.allRunCount }}</div>
            </div>
          </div>
          <div class="d-allcenter" style="width: 100%; height: 480px">
            <el-image
              v-show="!!currVenuesData.url"
              style="width: 100%; height: 480px"
              fit="cover"
              :src="currVenuesData.url"
              :preview-src-list="[currVenuesData.url]"
            ></el-image>
          </div>
          <div style="width: 840px">
            <active-data
              ref="activechildRef"
              :hoursData="hoursData"
              :size="size"
              :canChose="true"
              @changeDayDateActive="changeDayDateActive"
              :dayDateActive="dayDateActive"
            ></active-data>
          </div>
        </div>
        <div class="center-right d-column" v-if="rightShow" style="margin-top: -16px">
          <VenuesWeek ref="week" :weekDate="weekDate" @changeWeekDate="changeWeekDate"></VenuesWeek>
          <div style="height: 280px; margin-top: 16px">
            <month-data
              ref="monthChild"
              :monthColleges="monthColleges"
              :monthData="monthData"
              :monthDate="monthDate"
              :monthError="monthError"
              :type="type"
              :canChose="true"
              @changeMonthDate="changeMonthDate"
            ></month-data>
          </div>

          <div style="width: 540px; height: 306px; overflow: hidden; margin-left: 24px; margin-top: 16px">
            <VenuesTerm ref="term"></VenuesTerm>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="bottom d-aligncnter"></div>
    </MyScale>
  </div>
</template>
<script>
import {
  //   getOndDayRunInfo,
  //   getDayCollegeRunInfo,
  //   getMonthCollegeRunInfo,
  //   getLastDayRunInfo,
  getAllRunInfo,
  getToDayRunInfo,
  getVenueRunInfo,
  //   getTermRunInfo,
  warningExercise,
  getRunInfoByVenueId,
  getEntranceByVenueId,
  getWeekExerciseNum,
  getTermExerciseNum,
  getLastDayExerciseNum,
  getMonthExerciseNum,
  getOndDayExerciseByVenueId,
} from '@/api/api-cockpit'

import YesterdayData from './components/YesterdayData.vue'
import MonthData from './components/MonthData.vue'
import ActiveData from './components/ActiveData.vue'
// import SemesterData from './components/SemesterData.vue'

import MyScale from './components/MyScale.vue'
import CurrEnter from './components/CurrEnter.vue'
import VenuesTerm from './components/VenuesTerm.vue'
import VenuesWeek from './components/VenuesWeek.vue'
import MyWeather from '../../components/MyWeather.vue'
// import SemesterDataNew from './components/SemesterDataNew.vue'
// import CenterData from './components/CenterData.vue'
// import AbnormalData from './components/AbnormalData.vue'

// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: '',
  components: {
    YesterdayData,
    MonthData,
    ActiveData,
    // SemesterData,
    // SemesterDataNew,
    CurrEnter,
    MyScale,
    VenuesTerm,
    VenuesWeek,
    MyWeather,
  },
  //   directives: {
  //     swiper: directive,
  //   },
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      today: '',
      hoursData: [],
      dayCollegeData: [],
      monthCollegeData: [],
      monthData: [],
      monthError: [],
      monthColleges: [],
      semesterData: [],
      semesterDataNew: [],
      semesterDisData: [],
      colleges: [],
      lastSum: '',
      activeSum: '',
      activeTodaySum: '',
      venueData: [
        { venueName: '锻炼场', number: 15 },
        { venueName: '锻炼场', number: 18 },
      ],
      sloganData: [
        { lineOne: '体育无处不在', lineTwo: '运动无限精彩' },
        { lineOne: '你心我心运动同心', lineTwo: '你行我行健康同行' },
        { lineOne: '体育生活化', lineTwo: '生活体育化' },
      ],
      sloganIndex: 0,
      abnormalData: [],
      timer: null,
      swiperOptions: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
          dynamicBullets: false,
        },
        speed: 2000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        effect: 'slide',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      centerShow: true,
      leftShow: true,
      rightShow: true,
      currTitle: '',
      venueId: '',
      currVenuesData: {},
      enterData: [],
      videoHeight: '500px',
      size: 'large',
      type: 'eachVenue',
      dayDateActive: '', //24小时活跃度日期
      dayDate: '',
      monthDate: '',
      weekDate: '',
    }
  },
  created() {
    let getMyDate = new Date()
    this.dayDate = this.formatDate(getMyDate.getTime())
    this.dayDateActive = this.formatDate(getMyDate.getTime()) //24小时活跃度日期
    this.monthDate = this.formatDateMonth(getMyDate.getTime())
    this.weekDate = this.formatDate(getMyDate.getTime())
    this.currTitle = this.$route.query.title
    this.venueId = this.$route.query.venueId
    getRunInfoByVenueId(this.venueId).then((res) => {
      console.log('getRunInfoByVenueId:', res)
      this.currVenuesData = res.data.obj
    })
    getEntranceByVenueId(this.venueId).then((res) => {
      console.log('getEntranceByVenueId:', res)
      this.enterData = res.data.obj
    })
    this.placeholderPic()
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday

    const that = this
    //24小时活跃人次+轮询
    this.getHoursInfo()
    // this.timer1 = setInterval(() => {
    //   that.getHoursInfo()
    // }, 2000)
    //昨日各学院跑步人数
    this.getDayCollegeData()
    this.getYesterdaySum()
    this.getActiveSum()
    // this.timer2 = setInterval(() => {
    //   that.getActiveSum()
    // }, 60000)
    //学院月跑步人数+轮询
    this.getMonthCollegeData()
    //场地数据
    this.getVenueData()
    // this.timer3 = setInterval(() => {
    //   that.getVenueData()
    // }, 60000)
    //学期各学院数据
    this.getTermData()
    this.getTermDataNew()
    this.getWarningExercise()
    this.weekExerciseNum()
    this.termExerciseNum()
    this.timer = setInterval(() => {
      that.getHoursInfo()
      that.getActiveSum()
      that.getVenueData()
      that.getWarningExercise()
      this.getTermDataNew()
      this.getMonthCollegeData()
      this.getDayCollegeData()
      this.weekExerciseNum()
      this.termExerciseNum()
      this.getYesterdaySum()
    }, 60000)
  },
  mounted() {
    // window.WIDGET = {
    //   CONFIG: {
    //     modules: '02',
    //     background: '5',
    //     tmpColor: 'FFFFFF',
    //     tmpSize: '16',
    //     cityColor: 'FFFFFF',
    //     citySize: '16',
    //     aqiColor: 'FFFFFF',
    //     aqiSize: '16',
    //     weatherIconSize: '24',
    //     alertIconSize: '18',
    //     padding: '10px 10px 10px 10px',
    //     shadow: '0',
    //     language: 'auto',
    //     fixed: 'false',
    //     vertical: 'top',
    //     horizontal: 'left',
    //     key: '18dcc59e188b4b6684d470c4322bbefa',
    //   },
    // }
    // ;(function (d) {
    //   var c = d.createElement('link')
    //   c.rel = 'stylesheet'
    //   c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
    //   var s = d.createElement('script')
    //   s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
    //   var sn = d.getElementsByTagName('script')[0]
    //   sn.parentNode.insertBefore(c, sn)
    //   sn.parentNode.insertBefore(s, sn)
    // })(document)

    setInterval(() => {
      this.$refs.weatherTwo.initWeather()
    }, 3600000)

    let h = window.innerHeight
    this.videoHeight = h * 0.5 + 'px'
  },
  methods: {
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
    formatDateMonth(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      //   var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}`
      return formattedDate
    },
    changeSize(size) {
      console.log('size:', size)
      this.currScale = size
      //   this.mySize = this.mySize / size
      this.mySize = 5.208 / size
    },
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    //24小时活跃人次
    getHoursInfo() {
      getOndDayExerciseByVenueId(this.venueId, this.dayDateActive).then((res) => {
        if (res.data.statusCode == 1) {
          this.hoursData = res.data.obj.exerciseNum
          this.$refs.activechildRef.drawMonthData(res.data.obj.exerciseNums, res.data.obj.sortCodes)
          //   for (let i = 0; i < res.data.obj.length; i++) {
          //     this.hoursData.push(res.data.obj[i].lastRunCount)
          //   }
        }
      })
    },

    changeDayDateActive(date) {
      console.log('changeDayDateActive:', date)
      this.dayDateActive = date
      this.getHoursInfo()
    },
    changeDayDate(date) {
      console.log('changeDayDate222:', date)
      this.dayDate = date
      this.getDayCollegeData()
      //   this.changeTodaySum()
    },
    changeMonthDate(date) {
      console.log('changeMonthDate444:', date)
      this.monthDate = date
      this.getMonthCollegeData()
    },
    changeWeekDate(date) {
      console.log('changeWeekDate333:', date)
      this.weekDate = date
      this.weekExerciseNum()
    },
    //各学院作日人数
    getDayCollegeData() {
      getLastDayExerciseNum(this.venueId, this.dayDate).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('各学院作日人数:', res.data.obj)
          this.dayCollegeData = res.data.obj
        }
      })
    },
    //各学院月人数柱状图
    getMonthCollegeData() {
      getMonthExerciseNum(this.venueId, this.monthDate).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('各学院:', res.data.obj)
          this.monthCollegeData = res.data.obj
          this.rightShow = true
          this.leftShow = true
          this.monthData = res.data.obj.runCount
          this.monthColleges = res.data.obj.collegeName
          this.$refs.monthChild.refresh(this.monthData, this.monthColleges)
        }
      })
    },
    //作日总人数
    getYesterdaySum() {
      getLastDayExerciseNum().then((res) => {
        if (res.data.statusCode == 1) {
          this.leftShow = true
          this.lastSum = res.data.obj.lastRunCount
        }
      })
    },
    //动态总人数数值
    getActiveSum() {
      getAllRunInfo().then((res) => {
        if (res.data.statusCode == 1) {
          this.activeSum = res.data.obj.lastRunCount
        }
      })
      getToDayRunInfo().then((res) => {
        if (res.data.statusCode == 1) {
          this.activeTodaySum = res.data.obj.lastRunCount
        }
      })
    },
    //场地跑步情况
    getVenueData() {
      getVenueRunInfo().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('场地:', res.data.obj)
          this.venueData = res.data.obj
          this.centerShow = true
        }
      })
    },
    //学期数据
    getTermData() {
      //   getTermRunInfo().then((res) => {
      //     if (res.data.statusCode == 1) {
      //       if (res.data.statusCode == 1) {
      //         for (let i = 0; i < res.data.obj.length; i++) {
      //           this.semesterData.push(res.data.obj[i].lastRunCount)
      //           this.semesterDisData.push(res.data.obj[i].sumDistance)
      //           this.colleges.push(res.data.obj[i].collegeName)
      //         }
      //       }
      //     }
      //   })
    },
    //学期数据新
    getTermDataNew() {
      //semesterDataNew
      //   getTermRunInfo().then((res) => {
      //     console.log('新新：', res)
      //     if (res.data.statusCode == 1) {
      //       this.semesterDataNew = res.data.obj
      //       this.$refs.child.refresh(res.data.obj)
      //     }
      //   })
    },
    // 异常信息
    getWarningExercise() {
      warningExercise().then((res) => {
        if (res.data.statusCode == 1) {
          this.abnormalData = res.data.obj
        }
      })
    },
    //学期
    termExerciseNum() {
      getTermExerciseNum(this.venueId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('学期', res)
          this.$refs.term.refresh(res.data.obj)
        }
      })
    },
    //近7日
    weekExerciseNum() {
      getWeekExerciseNum(this.venueId, this.weekDate).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('近7日', res)
          this.$refs.week.refresh(res.data.obj)
        }
      })
    },
  },
  destroyed() {
    clearInterval(this.timer)
  },
}
</script>
<style scoped lang="scss">
.swiper {
  height: 100%;
  width: 100%;
}
.slide-show-content {
  width: 30vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.swiper-slide {
  width: 30vw !important;
}
.swiper-container {
  width: 30vw !important;
}
.jsc-bg {
  width: 100vw;
  //   min-width: 1200px;
  height: 100vh;
  //   min-height: 800px;
  overflow: hidden;
  background: #09120f;
  color: #fff;
  .top {
    width: 100%;
    height: 5.208vw;
    background: url('../../assets/img/cockpit/top.svg') no-repeat;
    background-size: 100%;
    position: relative;
    .sys-title {
      width: 100%;
      height: 100%;
      line-height: 5.208vw;
      vertical-align: middle;
      text-align: center;
      font-size: 1rem;
    }
    .sys-date,
    .sys-temp {
      font-size: 0.5rem;
      position: absolute;
    }
    .sys-date {
      line-height: 44px;
      top: calc(2.604vw - 18px);
      left: 6vw;
    }
    .sys-temp {
      top: calc(2.604vw - 22px);
      right: 6vw;
      display: flex;
      flex-direction: row-reverse;
    }
  }
  .center-left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .center {
    .center-left,
    .center-right {
      width: 560px;
      //   width: 26%;
      height: 950px;
      //   border: 1px solid #fff;
    }
    .center-center {
      width: 802px;
      //   width: 48%;;
      height: 950px;
      //   border: 1px solid #fff;
    }
  }
  .bottom {
    width: 1920px;
    // min-width: 1200px;
    height: 206px;
    // border: 1px solid #fff;
  }
}
.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}
.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}
.sys-temp ::v-deep #weather-view-he {
  display: none !important;
}
.slog {
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.imgbg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: url('../../assets/img/academic/circlebg.png') no-repeat;
  background-size: 36%;
  background-position: 50% 58%;
  z-index: 0;
}
.test-bg {
  width: 100%;
  height: 100%;
  margin-top: -5vh;
  position: absolute;
  background: url('../../assets/img/academic/circlebg.png') no-repeat;
  background-size: 100%;
  background-position: center;
  z-index: 0;
  //   animation: myrotate 1.6s linear infinite;
}
.t {
  font-size: 0.4rem;
}
.num {
  font-size: 0.6rem;
  margin-top: 8px;
  color: #339571;
  font-weight: 600;
  height: 30px;
}
.left-box {
  width: calc(100% - 24px) !important;
}

.bottom ::v-deep .active {
  margin-top: 0px;
}
.center-left ::v-deep .echarts {
  height: 236px;
}
</style>
